var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block text-center"},[(_vm.status.warning)?_c('v-icon',{attrs:{"color":"red"}},[_vm._v("warning")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.status.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }